import React, { useState } from "react";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import SaveIcon from "@mui/icons-material/Save";
import SuccessButton from "../../organisms/SuccessButton";
import {
  GrupoUsuario,
  UsuarioListado,
  modificarUsuario,
} from "../../../services/seguridadServicios";

interface FilaUsuarioProps {
  usuario: UsuarioListado;
  grupos: GrupoUsuario[];
  indice: number;
}

const VALOR_INACTIVOS = "";

function FilaUsuario({ usuario, grupos, indice }: FilaUsuarioProps) {
  const [grupoSeleccionado, setGrupoSeleccionado] = useState(
    usuario.grupoUsuario?.id ?? VALOR_INACTIVOS
  );
  const [ultimoValorGuardado, setUltimoValorGuardado] = useState(
    usuario.grupoUsuario?.id ?? VALOR_INACTIVOS
  );
  const [estaGuardando, setEstaGuardando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const haCambiado = grupoSeleccionado !== ultimoValorGuardado;

  const onGuardar = async () => {
    setEstaGuardando(true);
    setError(null);

    try {
      await modificarUsuario({
        id: usuario.id,
        body: {
          grupoUsuario:
            grupoSeleccionado === VALOR_INACTIVOS
              ? null
              : grupoSeleccionado,
        },
      });
      setUltimoValorGuardado(grupoSeleccionado);
    } catch {
      setGrupoSeleccionado(ultimoValorGuardado);
      setError("Error al guardar el cambio. Revertido al valor anterior.");
    } finally {
      setEstaGuardando(false);
    }
  };

  return (
    <ListGroup.Item as="li" className="d-flex mt-2 p-1 border rounded">
      <div className="ps-2 w-100">
        <div className="row">
          <div className="col">{usuario.email}</div>
        </div>
        <div className="d-flex flex-column" style={{ gap: 2 }}>
          <small className="text-muted">Grupo de usuario</small>
          <div className="d-flex align-items-center gap-2">
          <Form.Select
            className="flex-grow-1"
            value={grupoSeleccionado}
            onChange={(e) => setGrupoSeleccionado(e.target.value)}
            disabled={estaGuardando}
          >
            <option value={VALOR_INACTIVOS}>INACTIVOS</option>
            {grupos.map((grupo) => (
              <option key={grupo.id} value={grupo.id}>
                {grupo.codigo}
              </option>
            ))}
          </Form.Select>
          <div style={{ width: 38, display: "flex", alignItems: "center", justifyContent: "center" }}>
            {haCambiado && !estaGuardando && (
              <SuccessButton size="sm" onClick={onGuardar}>
                <SaveIcon sx={{ fontSize: 18 }} />
              </SuccessButton>
            )}
            {estaGuardando && (
              <Spinner animation="border" size="sm" role="status">
                <span className="visually-hidden">Guardando...</span>
              </Spinner>
            )}
          </div>
        </div>
        </div>
        {error && (
          <small className="text-danger" role="alert">
            {error}
          </small>
        )}
      </div>
    </ListGroup.Item>
  );
}

export default FilaUsuario;
